import React from 'react';
import { useMatch } from 'react-router-dom';

interface LanguageSwitcherProps {
  selectedLanguage: 'gr' | 'en';
  handleLanguageChange: (language: 'gr' | 'en') => void;
  /** Smaller variant for the branch picker / welcome hero. */
  compact?: boolean;
}

/** GR / EN toggle. Hidden on the items page (the menu there is already loaded in one language). */
function LanguageSwitcher({ selectedLanguage, handleLanguageChange, compact = false }: LanguageSwitcherProps) {
  const isItemsPage = useMatch('/items/:categoryID');

  if (isItemsPage) {
    return null;
  }

  return (
    <div
      className={`language-switcher${compact ? ' language-switcher--compact' : ''}`}
      role="group"
      aria-label={selectedLanguage === 'en' ? 'Language' : 'Γλώσσα'}
    >
      <button
        type="button"
        className={`language-option ${selectedLanguage === 'gr' ? 'active' : ''}`}
        aria-pressed={selectedLanguage === 'gr'}
        lang="el"
        onClick={() => handleLanguageChange('gr')}
      >
        GR
      </button>
      <button
        type="button"
        className={`language-option ${selectedLanguage === 'en' ? 'active' : ''}`}
        aria-pressed={selectedLanguage === 'en'}
        lang="en"
        onClick={() => handleLanguageChange('en')}
      >
        EN
      </button>
    </div>
  );
}

export default LanguageSwitcher;
